export const WAITING_ON_FUNDING_STATUSES: string[] = [
  'AT_LENDER_FOR_FUNDING',
  'AT_LENDER_FUNDING_PENDING',
  'FUNDING_DELAYED',
  'FUNDING_HOLD',
  'DEAL_RETURNED_BY_LENDER',
];
